<template>
  <div class="layout-tag-list">
    <module-list-title
      :moduleNameAndLength="moduleNameAndLength"
      :isBatchFlag="isBatchFlag"
      @batch="handleBatch"
      @batch-move="handleBatchMove"
      @batch-delete="handleBatchDelete"
      @batch-cancel="handleBatchCancel"
    />
    <div class="layout-tag-list-content" v-loading="loading">
      <kye-checkbox-group v-model="checkList">
        <div class="drag-box kye-scrollbar">
          <div class="add-tag-btn" @click="handleAdd">
            <img src="../../../images/add-plus.svg" />
            <span>添加常用</span>
          </div>
          <draggable ref="draggable"
                     class="drag-box-list"
                     tag="div"
                     :list="tags"
                     @change="onSortChange"
                     v-bind="dragOptions">
            <module-item v-for="tag in tags"
                         :key="tag.id"
                         :tag="tag"
                         :isBatchFlag="isBatchFlag"
                         :isActive="hasActived(tag.id)"
                         :menuIcon="menuIconMap[tag.url]"
                         @command="handleCommand"/>
          </draggable>
        </div>
      </kye-checkbox-group>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import ModuleListTitle from './module-list-title.vue'
  import ModuleItem from './module-item.vue'
  export default {
    props: {
      activeItem: Object,
      loading: {
        type: Boolean,
        default: false
      },
      menuIconMap: {
        type: Object,
        default: () => ({})
      }
    },
    components: { draggable, ModuleListTitle, ModuleItem },
    data() {
      return {
        tags: [],
        dragOptions: {
          draggable: '.menu-tag',
          handle: '.menu-tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        },
        checkList: [],
        isBatchFlag: false
      }
    },
    computed: {
      moduleNameAndLength() {
        return this.activeItem && this.activeItem.groupName ? `${this.activeItem.groupName}(${this.tags.length})` : ''
      }
    },
    watch: {
      // 监听 activeItem 变化，重新加载模块列表
      'activeItem.id': {
        handler(newId) {
          if (newId) {
            this.initTagList()
          }
        },
        immediate: true
      }
    },
    methods: {
      // 初始化模块列表
      async initTagList() {
        try {
          this.$emit('update:loading', true)
          const res = await this.$http('system.homeIndex.list', {
            moduleGroupId: this.activeItem.id,
            moduleType: 10
          })
          const menus = this.$store.getters.menus
          this.tags = res.filter(item => menus[item.url])
          this.initCheckData()
        } catch (e) {
          console.error(e)
          this.tags = []
        } finally {
          this.$emit('update:loading', false)
        }
      },
      initCheckData() {
        this.checkList = []
        this.isBatchFlag = false
      },
      handleBatch() {
        this.isBatchFlag = true
      },
      handleBatchMove() {
        if (!this.checkList.length) {
          this.$message.warning('请先勾选目标模块，然后继续操作')
          return
        }
        const tagVal = this.tags.filter(tag => this.checkList.includes(tag.id))
        this.$emit('move', tagVal)
      },
      async handleBatchDelete() {
        if (!this.checkList.length) {
          this.$message.warning('请先勾选目标模块，然后继续操作')
          return
        }
        await this.$confirm(`你确定要从“${this.activeItem.groupName}”分组中移除，移除后需要重新添加`)
        const tagVal = this.tags.filter(tag => this.checkList.includes(tag.id))
        const params = tagVal.map(item => item.id)
        await this.$http('system.homeIndex.deleteByIds', params)
        this.$message.success('删除成功！')
        await this.initTagList()
        this.$emit('update')
      },
      handleBatchCancel() {
        this.isBatchFlag = false
        this.checkList = []
      },
      hasActived(id) {
        return this.isBatchFlag && this.checkList.includes(id)
      },
      handleCommand(command, tag) {
        const value = Array.isArray(tag) ? tag : [tag]
        if (command === 'delete') {
          this.handleSingleDelete(value)
        } else {
          this.$emit(command, value)
        }
      },
      // 单个删除
      async handleSingleDelete(tags) {
        await this.$confirm(`你确定要从“${this.activeItem.groupName}”分组中移除，移除后需要重新添加`)
        const params = tags.map(item => item.id)
        await this.$http('system.homeIndex.deleteByIds', params)
        this.$message.success('删除成功！')
        await this.initTagList()
        this.$emit('update')
      },
      handleAdd() {
        this.$emit('add')
      },
      async onSortChange() {
        try {
          this.$emit('update:loading', true)
          const params = this.tags.map((item, index) => ({
            id: item.id,
            displaySequence: index + 1
          }))
          await this.$http('system.homeIndex.setHomeIndexSort', params)
          await this.initTagList()
          this.$emit('update')
        } catch (error) {
          console.error(error)
        } finally {
          this.$emit('update:loading', false)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-tag-list {
  padding-left: 212px;
  border-radius: 0 0 16px 16px;
  .layout-tag-list-content {
    box-sizing: border-box;
    padding: 16px 12px 12px;
    border-radius: 0 0 16px 0;
    .drag-box {
      height: calc(60vh - 24px);
      overflow-y: auto;
      border-radius: 2px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 12px;
      scroll-behavior: auto;
    }
    .drag-box-list {
      display: contents;
    }
    .add-tag-btn {
      width: 214px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-radius: 8px;
      border: 1px dashed rgba(121, 83, 246, 1);
      background: rgba(243, 242, 254, 1);
      color: var(--g-color-primary);
      cursor: pointer;
      font-size: 14px;
      flex-shrink: 0;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .drag-box-item {
      // 样式已移至 module-item.vue 组件
    }
  }
}
.layout-tag-action-row {
  display: flex;
  align-items: center;
  color: #000000 !important;
  &:hover {
    background: #EBECF0;
  }
  img {
    width: 12px;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/module-list/module-list.vue